<template>
  <el-dialog custom-class="xqjs-dialog" title="续期结算规则" :visible.sync="visible" width="1000px" append-to-body>
    <div class="warning-info">
      <p class="title">续期系数发放规则介绍：</p>
      <div class="info-table">
        <div class="table">
          <div class="table-row head border-bottom">
            <div class="td big-td">产品区分</div>
            <div class="td big-td5">续期时间</div>
            <div class="td big-td5 big-td55">继续率要求</div>
            <div class="td big-td6 big-td66">续期服务费发放比例</div>
          </div>
          <div class="table-row border-bottom" v-for="(item_1, index_1) in ruleList1" :key="index_1">
            <div class="merge-td big-td">
              {{ item_1.name }}
            </div>
            <div class="box">
              <div class="table-row-child" v-for="(item_2, index_2) in item_1.payNums" :key="index_2">
                <div class="merge-td big-td5">
                  {{ item_2.payNumDesc || "--" }}
                </div>
                <div class="box">
                  <div class="table-row-child" v-for="(item_3, index_3) in item_2.renewalRates" :key="index_3">
                    <div class="td big-td5" v-if="item_1.isCalRate">
                      <template v-if="item_3.max&&item_3.min">
                        <span v-if="item_3.min">{{ item_3.min }}%≤</span>
                        {{
                          item_1.type == 1
                            ? "产品继续率"
                            : "整体继续率"
                        }}
                        <span v-if="item_3.max">&lt;{{ item_3.max }}%</span>
                      </template>
                      <template v-else-if="item_3.min">
                        {{
                          item_1.type == 1
                            ? "产品继续率"
                            : "整体继续率"
                        }}
                        <span v-if="item_3.min">≥{{ item_3.min }}%</span>
                      </template>
                    </div>
                    <div class="td big-td5" v-else>无继续率要求</div>
                    <div class="td big-td6">发放{{ item_3.sendRate }}%续期服务费</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="warning-info">
      <p class="title">继续率的计算公式：</p>
      <div class="body-info">
        a.13个月保费继续率=上年同期生效的个人长期险期缴保单生效后第13个月+60天宽限期内的实收保费/上年同期生效的个人长期险期应收保费×100%。
      </div>
      <div class="body-info">
        b.25个月保费继续率=前年同期生效的个人长期险期缴保单生效后第25个月+60天宽限期内的实收保费/上年同期生效的个人长期险期应收保费×100%。
      </div>
    </div>
    <div class="warning-info">
      <p class="title">继续率统计口径：</p>
      <div class="body-info">
        a.理赔终止/犹豫期内退保/豁免保费/趸交业务不纳入统计。
      </div>
      <div class="body-info">
        b.犹豫期外退保业务纳入分母（应收保费）、不纳入分子（实收保费）。
      </div>
      <div class="body-info">c.考核以所有商品为维度，不含1年期商品。</div>
    </div>
    <div class="warning-info">
      <p class="title">继续率奖金发放规则：</p>
      <div class="info-table" v-if="mechanUserType==1">
        <el-table :data="regulation" :header-cell-style="returnStyle" border>
          <el-table-column property="ditchType" label="渠道类型" align="center"></el-table-column>
          <el-table-column property="productType" label="产品类型" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column property="time" label="续期服务费发放时间" align="center"></el-table-column>
          <el-table-column property="rate" label="续期服务费发放比例" align="center"></el-table-column>
        </el-table>
      </div>
      <div v-else>
        <el-table :data="regulation2" :header-cell-style="returnStyle" border>
          <el-table-column property="ditchType" label="渠道类型" align="center"></el-table-column>
          <el-table-column property="productType" label="产品类型" align="center" show-overflow-tooltip></el-table-column>
          <el-table-column property="time" label="续期服务费发放时间" align="center"></el-table-column>
          <el-table-column property="rate" label="续期服务费发放比例" align="center"></el-table-column>
        </el-table>
      </div>
    </div>

    <div class="warning-info">
      <p class="title">特别说明：</p>
      <div class="body-info">
        a.续期缴费确认信息由保险公司发出，可能存在一定延误情况
      </div>
    </div>
    <div class="warning-info">
      <p class="title">举例：</p>

      <div v-if="mechanUserType==1">
        <div class="userType">企业类用户：</div>
        <div class="body-info">
          2019年9月1日-2019年9月30日生效的保单，续期缴费日为2020年9月1日-2020年11月30日，服务费生效（下发）日为2021年1月10日
        </div>
      </div>
      <div v-else>
        <div class="userType">个人用户：</div>
        <div class="body-info">
          2019年9月1日-2019年9月30日生效的保单，续期缴费日为2020年9月1日-2020年11月30日，服务费生效（下发）日为2021年1月10日
        </div>
      </div>
    </div>
    <div class="warning-info" v-for="(item_1, index_1) in ruleList2" :key="index_1">
      <p class="title">{{item_1.ruleTypeName}}：</p>
      <div class="table">
        <div class="table-row head border-bottom">
          <div class="td big-td">产品区分</div>
          <div class="td big-td5">续期时间</div>
          <div class="td big-td5 big-td55">继续率要求</div>
          <div class="td big-td6 big-td66">续期服务费发放比例</div>
        </div>
        <div class="table-row border-bottom">
          <div class="merge-td big-td">
            {{ item_1.name }}
          </div>
          <div class="box">
            <div class="table-row-child" v-for="(item_2, index_2) in item_1.payNums" :key="index_2">
              <div class="merge-td big-td5">
                {{ item_2.payNumDesc || "--" }}
              </div>
              <div class="box">
                <div class="table-row-child" v-for="(item_3, index_3) in item_2.renewalRates" :key="index_3">
                  <div class="td big-td5" v-if="item_1.isCalRate">
                    <template v-if="item_3.max&&item_3.min">
                      <span v-if="item_3.min">{{ item_3.min }}%≤</span>
                      {{
                        item_1.type == 1
                          ? "产品继续率"
                          : "整体继续率"
                      }}
                      <span v-if="item_3.max">&lt;{{ item_3.max }}%</span>
                    </template>
                    <template v-else-if="item_3.min">
                      {{
                        item_1.type == 1
                          ? "产品继续率"
                          : "整体继续率"
                      }}
                      <span v-if="item_3.min">≥{{ item_3.min }}%</span>
                    </template>
                  </div>
                  <div class="td big-td5" v-else>无继续率要求</div>
                  <div class="td big-td6">发放{{ item_3.sendRate }}%续期服务费</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="table-row border-bottom">
          <div class="merge-td big-td">
            产品名称 
          </div>
          <div class="box">
            <div class="table-row-child" v-for="(bean, index) in item_1.productNames" :key="index">
              <div class="merge-td big-td5">
                {{index+1}}
              </div>
              <div class="box">
                <div class="table-row-child">
                  <div class="td big-td7">
                    {{bean}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default {
  props: {},
  data() {
    return {
      visible: false,
      mechanUserType: null,
      regulation: [
        {
          ditchType: '企业类用户',
          productType: '所有产品',
          time: '宽限期后第2个月10日',
          rate: '100%',
        },
      ],
      regulation2: [
        {
          ditchType: '个人类用户',
          productType: '所有产品',
          time: '宽限期后第2个月10日',
          rate: '100%',
        },
      ],
      ruleList1:[],//整体数据
      ruleList2:[],//附录
    }
  },
  created() {},
  mounted() {},
  methods: {
    open() {
      const loading = this.$notice.loading();
      this.$http({
        url: "/master/product/queryRuleList",
        type: "put",
        params: {},
      }).then((res) => {
        this.visible = true
        this.ruleList1 = res.data;
        this.ruleList2 = res.data.filter(item=>{
          if(!!item.ruleType && item.productNames){
            item.productNames = item.productNames.split(',')
            return true
          }
          return false
        })
        loading.close();
      })
    },
    returnStyle() {
      return { background: '#F7F7F7', 'text-align': 'center' }
    },
  },
}
</script>
<style lang="scss">
@import './xfdExplainModal.scss';
</style>
